// Modules
import { useCallback, useEffect, useState } from "react";
import { useRouter } from "next/router";

// Hooks
import useRouting from "hooks/useRouting";

// Constants
import { QueryStringPrimaryKeys } from "constants/searchPage/urlEnum";

// Utils
import { removeSpecificKeyFromQueryString } from "utils/searchPage/queryString";

const QueryFilter = () => {
	const router = useRouter();
	const pushNewRoute = useRouting();
	const [searchParam, setSearchParam] = useState<string>();

	useEffect(() => {
		const search = router.query[QueryStringPrimaryKeys.SEARCH];
		if (typeof search === "string") {
			setSearchParam(search.toUpperCase());
		} else {
			setSearchParam(undefined);
		}
	}, [router.query]);

	const removeFilter = useCallback(() => {
		const newQueryString = removeSpecificKeyFromQueryString(router.query, QueryStringPrimaryKeys.SEARCH);
		pushNewRoute(newQueryString);
	}, [router.query]);

	return searchParam ? (
		<div className="wk-choosen-filter">
			<span className="wk-icon-close" tabIndex={0} aria-label="Delete filter" role="button" onClick={removeFilter} />
			<span className="wk-choosen-filter-label">
				<p>RICERCA</p>: {searchParam}
			</span>
		</div>
	) : (
		<></>
	);
};

export default QueryFilter;
